import React, { useMemo } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { checkPermissions } from "../utils/getRolesAndPermissions";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import getUserDetail from "./getUserDetail";
import getSessionToken from "./getSessionToken";
import { getPermissions } from "./getRolesAndPermissions";
import { removeItem } from "./cooke-data";

const ProtectedRoute = ({ requiredPermission, children }) => {
  const location = useLocation();

  const user = useMemo(() => getUserDetail(), []);
  const token = useMemo(() => getSessionToken(), []);
  const permissions = useMemo(() => getPermissions(), []);

  const isAuthenticated = !!(user?.id && token && permissions);

  const hasPermission = useMemo(() => {
    if (!requiredPermission) return true;
    return checkPermissions(requiredPermission, true);
  }, [requiredPermission]);

  if (!isAuthenticated) {
    if (user || token || permissions) {
      // Something is missing but not everything, clear all to be safe
      removeItem("user");
      removeItem("userRole");
      removeItem("permissions");
      removeItem("session_token");
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermission && !hasPermission) {
    return <PageNotFound />;
  }

  return children ? children : <Outlet />;
};

export default React.memo(ProtectedRoute);
